import {
  dynamicCollectionRendererKey,
  dynamicElementsSimpleTextKey,
} from '@epicuro-next/constants/dynamic-elements';
import {
  ProductListConfigurationKeys,
  PRODUCT_LIST_NAMESPACE,
} from '@epicuro-next/constants/rule-engine/product-list-rules';
import {
  CONFIGURATIONS_PROVIDER_KEY,
  OPENED_LIST_DATA_PROVIDER_KEY,
} from '@epicuro-next/data-providers/providers-registry';

import { defaultDetailsCommercial } from './details-commercial/details-commercial.config';
import { defaultDetailsPowerConfig } from './details-power/details-power.config';
import {
  epicShowIf,
  isCommercialList,
  isNotCommercialList,
  isOwnerOfOpenedList,
} from './if-statements/if-statements';
import { authorItem } from './items/author-item';
import { getActionsDropdownDefaultConfig } from './items/dropdown-config';
import { hotListIndicatorItem } from './items/hot-list-indicator-item';
import { listDescriptionItem } from './items/list-description-item';
import { listNameNonEditableItem } from './items/list-name-item';
import { listProductsConfigDefault } from './items/list-products.config';
import { previewListButtonItem } from './items/preview-button-config';
import { shareListButtonItem } from './items/share-list-button-item';
import { shopTheListButtonItem } from './items/shop-the-list-button-item';
import {
  promoteEmailIf,
  promoteSpotlightIf,
  tabsConfigDefault,
} from './tabs-config/tabs.config';

// tslint:disable:no-duplicate-string

// USED FOR MarcoPolo, Birkenstock
export const defaultConfig = {
  listsCaption: {
    styles: { classes: ['container-fluid', 'mt-3'] },
    items: [
      {
        contentTypeId: dynamicCollectionRendererKey,
        if: isNotCommercialList,
        styles: { classes: ['row', 'align-items-center', 'my-3'] },
        inputs: {
          items: [
            {
              ...authorItem,
              styles: { classes: ['col', 'order-md-1', 'order-2'] },
            },
            {
              contentTypeId: dynamicCollectionRendererKey,
              styles: {
                classes: [
                  'col-12',
                  'col-md-6',
                  'order-1',
                  'order-md-2',
                  'd-flex',
                  'flex-column',
                  'justify-content-center',
                  'align-items-center',
                ],
              },
              inputs: {
                items: [
                  {
                    contentTypeId: dynamicCollectionRendererKey,
                    styles: {
                      classes: [
                        'd-inline-flex',
                        'align-items-center',
                        'position-relative',
                        'px-4',
                      ],
                    },
                    inputs: {
                      items: [
                        hotListIndicatorItem,
                        listNameNonEditableItem,
                        shareListButtonItem,
                      ],
                    },
                  },
                  {
                    contentTypeId: dynamicElementsSimpleTextKey,
                    inputs: {
                      text: {
                        provider: OPENED_LIST_DATA_PROVIDER_KEY,
                        property: 'productCountText',
                      },
                    },
                    styles: {
                      classes: ['text-muted'],
                    },
                  },
                ],
              },
            },
            {
              contentTypeId: dynamicCollectionRendererKey,
              styles: {
                classes: ['col', 'd-flex', 'justify-content-end', 'order-3'],
              },
              inputs: {
                items: [
                  getActionsDropdownDefaultConfig(),
                  shopTheListButtonItem,
                  previewListButtonItem,
                ],
              },
            },
          ],
        },
      },
      {
        contentTypeId: dynamicCollectionRendererKey,
        if: isNotCommercialList,
        styles: { classes: ['row', 'my-2'] },
        inputs: {
          items: [
            {
              ...listDescriptionItem,
              styles: {
                classes: ['col-12', 'd-flex', 'justify-content-center'],
              },
            },
          ],
        },
      },
      {
        contentTypeId: dynamicCollectionRendererKey,
        styles: { classes: ['row'] },
        inputs: {
          items: [
            {
              contentTypeId: dynamicCollectionRendererKey,
              styles: {
                classes: ['col-12'],
              },
              inputs: {
                items: [
                  {
                    ...tabsConfigDefault,
                    children: [
                      {
                        contentTypeId: dynamicCollectionRendererKey,
                        inputs: {
                          items: [
                            {
                              ...getActionsDropdownDefaultConfig(
                                true,
                                isCommercialList,
                              ),
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
            },
          ],
        },
        if: [
          'OR',
          [
            ['OR', [epicShowIf, ['OR', [promoteSpotlightIf, promoteEmailIf]]]],
            [
              'OR',
              [
                isOwnerOfOpenedList,
                [
                  'EQ',
                  [
                    {
                      provider: CONFIGURATIONS_PROVIDER_KEY,
                      property: {
                        namespace: PRODUCT_LIST_NAMESPACE,
                        featureName:
                          ProductListConfigurationKeys.AllowEditionListsNotOwned,
                        defaultValue: false,
                      },
                    },
                    true,
                  ],
                ],
              ],
            ],
          ],
        ],
      },
    ],
  },
  details: {
    items: [
      {
        contentTypeId: dynamicCollectionRendererKey,
        styles: {
          classes: ['row'],
        },
        inputs: {
          items: [
            {
              contentTypeId: dynamicCollectionRendererKey,
              styles: {
                classes: ['col-12'],
              },
              inputs: {
                items: [listProductsConfigDefault],
              },
            },
          ],
        },
      },
    ],
  },
  detailsCommercial: defaultDetailsCommercial(),
  detailsPower: defaultDetailsPowerConfig,
};
